import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import ExpandMoreOutlinedIcon from "@mui/icons-material/ExpandMoreOutlined";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import MenuIcon from "@mui/icons-material/Menu";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import { useWindowSize } from "@uidotdev/usehooks";
import PropTypes from "prop-types";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { ReactComponent as OpenBook } from "../../assets/svg/open-book.svg";
import { ReactComponent as PlusCircle } from "../../assets/svg/plus-circle.svg";
import { ReactComponent as ShoppingBag } from "../../assets/svg/shopping-bag.svg";
import { LeafButton, PoppyButton } from "../button";

export const Header = ({ logo }) => {
  const { width } = useWindowSize();
  const navigate = useNavigate();
  // Translate
  const { t } = useTranslation();
  // Begin: navLinks
  const navLinks = [
    {
      name: "header.product",
      path: "/facialsense-bio-attendance",
      position: "",
      subnav: [
        {
          name: "header.subproduct.0.name",
          item: [
            {
              name: "",
              item: [
                {
                  name: "header.subproduct.0.item.0.item.0.name",
                  path: "/facialsense-bio-attendance",
                },
                {
                  name: "header.subproduct.0.item.0.item.1.name",
                  path: "/facialsense-visitor-management",
                },
              ],
            },
          ],
        },
      ],
    },
    {
      name: "header.industries",
      position: "-left-36",
      subnav: [
        {
          name: "header.subindustries.0.name",
          item: [
            {
              name: "",
              item: [
                {
                  name: "header.subindustries.0.item.0.item.0.name",
                  path: "/office-employee-time-attendance-monitoring-system",
                },
                {
                  name: "header.subindustries.0.item.0.item.1.name",
                  path: "/retail-workforce-time-attendance-monitoring-system",
                },
                {
                  name: "header.subindustries.0.item.0.item.2.name",
                  path: "/mobile-workforce-time-attendance-monitoring-system",
                },
                {
                  name: "header.subindustries.0.item.0.item.3.name",
                  path: "/biometric-school-attendance-monitoring-system",
                },
                {
                  name: "header.subindustries.0.item.0.item.4.name",
                  path: "/construction-site-time-attendance-monitoring-system",
                },
                {
                  name: "header.subindustries.0.item.0.item.5.name",
                  path: "/hospital-time-attendance-monitoring-system",
                },
                {
                  name: "header.subindustries.0.item.0.item.6.name",
                  path: "/service-and-hospitality-time-attendance-monitoring-system",
                },
                {
                  name: "header.subindustries.0.item.0.item.7.name",
                  path: "/factory-and-warehouse-employee-time-attendance-monitoring-system",
                },
                {
                  name: "header.subindustries.0.item.0.item.8.name",
                  path: "/agriculture-sector-time-attendance-monitoring-system",
                },
              ],
            },
          ],
        },
        {
          name: "header.subindustries.1.name",
          item: [
            {
              name: "",
              item: [
                {
                  name: "header.subindustries.1.item.0.item.0.name",
                  path: "/meet-a-person-in-organization",
                },
                {
                  name: "header.subindustries.1.item.0.item.1.name",
                  path: "/travel-and-excursion",
                },
                {
                  name: "header.subindustries.1.item.0.item.2.name",
                  path: "/banking-or-financial-institutes",
                },
                {
                  name: "header.subindustries.1.item.0.item.3.name",
                  path: "/hotels-and-restaurants",
                },
                {
                  name: "header.subindustries.1.item.0.item.4.name",
                  path: "/consultation-services",
                },
                {
                  name: "header.subindustries.1.item.0.item.5.name",
                  path: "/buildings-and-apartments",
                },
                {
                  name: "header.subindustries.1.item.0.item.6.name",
                  path: "/customer-support",
                },
                {
                  name: "header.subindustries.1.item.0.item.7.name",
                  path: "/entertainment",
                },
                {
                  name: "header.subindustries.1.item.0.item.8.name",
                  path: "/schools-and-campuses",
                },
              ],
            },
          ],
        },
      ],
    },
    {
      name: "header.pricing",
      path: "/pricing",
      position: "",
      // subnav: [
      //   {
      //     name: "header.subpricing.0.name",
      //     item: [
      //       {
      //         name: "",
      //         item: [
      //           {
      //             name: "header.subpricing.0.item.0.item.0.name",
      //             path: "/pricing",
      //           },
      //           {
      //             name: "header.subpricing.0.item.0.item.1.name",
      //             path: "/pricing-visitor-management",
      //           },
      //         ],
      //       },
      //     ],
      //   },
      // ],
    },
    {
      name: "header.resources",
      path: "",
      position: "-right-[370px]",
      subnav: [
        {
          name: "header.subresources.0.name",
          item: [
            {
              name: (
                <div className="flex items-center gap-[10px] uppercase">
                  <ShoppingBag />
                  {t("header.subresources.0.item.0.name")}
                </div>
              ),
              item: [
                {
                  name: "header.subresources.0.item.0.item.0.name",
                  path: "#",
                },
                {
                  name: "header.subresources.0.item.0.item.1.name",
                  path: "#",
                },
                {
                  name: "header.subresources.0.item.0.item.2.name",
                  path: "#",
                },
              ],
            },
            {
              name: (
                <div className="flex items-center gap-[10px] uppercase">
                  <ShoppingBag />
                  {t("header.subresources.0.item.1.name")}
                </div>
              ),
              item: [
                {
                  name: "header.subresources.0.item.1.item.0.name",
                  path: "#",
                },
                {
                  name: "header.subresources.0.item.1.item.1.name",
                  path: "#",
                },
                {
                  name: "header.subresources.0.item.1.item.2.name",
                  path: "#",
                },
              ],
            },
            {
              name: (
                <div className="flex items-center gap-[10px] uppercase">
                  <PlusCircle />
                  {t("header.subresources.0.item.2.name")}
                </div>
              ),
              item: [
                {
                  name: "header.subresources.0.item.2.item.0.name",
                  path: "#",
                },
                {
                  name: "header.subresources.0.item.2.item.1.name",
                  path: "#",
                },
                {
                  name: "header.subresources.0.item.2.item.2.name",
                  path: "#",
                },
                {
                  name: "header.subresources.0.item.2.item.3.name",
                  path: "#",
                },
                {
                  name: "header.subresources.0.item.2.item.4.name",
                  path: "#",
                },
              ],
            },
          ],
        },
        {
          name: "header.subresources.1.name",
          item: [
            {
              name: (
                <div className="flex items-center gap-[10px] uppercase">
                  <OpenBook />
                  {t("header.subresources.1.item.0.name")}
                </div>
              ),
              item: [
                {
                  name: "header.subresources.1.item.0.item.0.name",
                  path: "/facialsense-bio-attendance",
                },
                {
                  name: "header.subresources.1.item.0.item.1.name",
                  path: "/facialsense-visitor-management",
                },
                {
                  name: "header.subresources.1.item.0.item.2.name",
                  path: "#",
                },
              ],
            },

            {
              name: (
                <div className="flex items-center gap-[10px] uppercase">
                  <PlusCircle />
                  {t("header.subresources.1.item.1.name")}
                </div>
              ),
              item: [
                {
                  name: "header.subresources.1.item.1.item.0.name",
                  path: "#",
                },
                {
                  name: "header.subresources.1.item.1.item.1.name",
                  path: "#",
                },
                {
                  name: "header.subresources.1.item.1.item.2.name",
                  path: "#",
                },
                {
                  name: "header.subresources.1.item.1.item.3.name",
                  path: "#",
                },
              ],
            },
          ],
        },
        {
          name: "header.subresources.2.name",
          item: [
            {
              name: (
                <div className="flex items-center gap-[10px] uppercase">
                  <ShoppingBag />
                  {t("header.subresources.2.item.0.name")}
                </div>
              ),
              item: [
                {
                  name: "header.subresources.2.item.0.item.0.name",
                  path: "#",
                },
                {
                  name: "header.subresources.2.item.0.item.1.name",
                  path: "#",
                },
              ],
            },

            {
              name: (
                <div className="flex items-center gap-[10px] uppercase">
                  <ShoppingBag />
                  {t("header.subresources.2.item.1.name")}
                </div>
              ),
              item: [
                {
                  name: "header.subresources.2.item.1.item.0.name",
                  path: "#",
                },
                {
                  name: "header.subresources.2.item.1.item.1.name",
                  path: "#",
                },
              ],
            },
          ],
        },
      ],
    },
    {
      name: "header.company",
      path: "",
      position: "",
      subnav: [
        {
          name: "header.subcompany.0.name",
          item: [
            {
              name: "",
              item: [
                {
                  name: "header.subcompany.0.item.0.item.0.name",
                  path: "/about-us",
                },
                {
                  name: "header.subcompany.0.item.0.item.1.name",
                  path: "/contact-us",
                },
                {
                  name: "header.subcompany.0.item.0.item.2.name",
                  path: "#",
                },
                {
                  name: "header.subcompany.0.item.0.item.3.name",
                  path: "/register-as-a-distributor",
                },
                {
                  name: "header.subcompany.0.item.0.item.4.name",
                  path: "#",
                },
                {
                  name: "header.subcompany.0.item.0.item.5.name",
                  path: "#",
                },
              ],
            },
          ],
        },
      ],
    },
  ];
  // End: navLinks
  //Begin: toggle menu
  const [menuOpen, setMenuOpen] = useState(false);
  const handleDrawerToggle = () => {
    setMenuOpen(!menuOpen);
  };
  //End: toggle menu
  return (
    <header className=" w-full h-32 py-8 lg:py-2 lg:h-auto z-10">
      <div className="flex max-w-[1300px] md:max-w-[90%] smAndmd:max-w-[90%] exact1024:max-w-[90%] justify-between items-center px-2  mx-auto">
        <a
          href="/"
          className="h-[66px] -ml-9 xlg:-ml-7 cursor-pointer"
          title="CheckID FacialSense Service"
        >
          <img
            className="h-full xlg:h-[80%]"
            src={logo}
            alt=" CheckID FacialSense Service"
          />
        </a>

        <div className="flex gap-10 items-center exact1024:hidden lg:hidden">
          <nav>
            <ul className="flex gap-5 uppercase text-sm font-medium text-white items-center">
              {navLinks.map((link) => (
                <li
                  key={t(link.name)}
                  className="relative group/nav py-5 cursor-pointer"
                >
                  <Link
                    to={link.path}
                    className="2xl:hover:text-gray-400 group-hover/nav:text-[#F7941D] flex items-center justify-between after:block  after:absolute after:transition-[all] after:duration-[500ms] after:left-0 after:w-0 after:group-hover/nav:w-full  after:top-4 after:border-t-[3px] after:border-[var(--tree-poppy)] "
                  >
                    {t(link.name)}
                    {link.subnav && (
                      <KeyboardArrowDownRoundedIcon className="group-hover/nav:rotate-180 rotate-0 transition-[all] duration-[2000ms]" />
                    )}
                  </Link>
                  {link.subnav && (
                    <div
                      className={`hidden gap-5 absolute normal-case shadow-lg z-10 top-16 xlg:top-20 xlg:mr-[50%] ${link.position}  group-hover/nav:flex group-hover/nav:animate-show-nav  bg-white text-black font-semibold p-5  rounded`}
                    >
                      {link?.subnav.map((subnav) => (
                        <div className="flex flex-col" key={subnav.name}>
                          {subnav.name && (
                            <h3 className="font-semibold text-sm uppercase text-[#151686] mb-[10px]">
                              {t(subnav.name)}
                            </h3>
                          )}

                          <ul className="w-[356px] xlg:w-[250px]">
                            {subnav.item.map((sublink, index) => (
                              <div className="group/subnavlink" key={index}>
                                {sublink.name && (
                                  <h4 className="text-[12px] xlg:text-[8px] text-[#607D94] font-medium rounded group-hover/subnavlink:text-[#958FED] group-hover/subnavlink:bg-[#F2F5FE] mb-2">
                                    {sublink.name}
                                  </h4>
                                )}
                                {sublink.item &&
                                  sublink.item.map((item) => (
                                    <li key={t(item.name)} className="">
                                      <Link
                                        to={item.path}
                                        className="flex p-[10px] xlg:text-[10px] items-center justify-between text-nowrap font-normal hover:bg-[#EEF3FA] hover:text-[#151686] hover:font-semibold rounded"
                                      >
                                        {t(item.name)}
                                      </Link>
                                    </li>
                                  ))}
                              </div>
                            ))}
                          </ul>
                        </div>
                      ))}
                    </div>
                  )}
                </li>
              ))}
            </ul>
          </nav>
          {/* Desktop */}
          <div className="flex gap-5">
            <a
              href="https://facialsense.mobile-id.vn/portal/login"
              target="_blank"
              rel="noopener noreferrer"
            >
              <PoppyButton title={t("header.login")} />
            </a>

            <a
              href="https://facialsense.mobile-id.vn/portal/sign-up"
              target="_blank"
              rel="noopener noreferrer"
            >
              <LeafButton title={t("header.signup")} />
            </a>
          </div>
        </div>
        <IconButton
          aria-label="Open Menu"
          edge="start"
          onClick={handleDrawerToggle}
          sx={{ padding: "15px", display: width > 1024 ? "none" : "block" }}
        >
          <MenuIcon sx={{ fontSize: "45px", color: "#ccc" }} />
        </IconButton>
      </div>

      <Drawer
        anchor="right"
        variant="temporary"
        open={menuOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          display: width > 1024 ? "none" : "block",
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: width < 450 ? "100%" : "450px",
          },
        }}
      >
        <nav className="relative pt-10">
          <button
            className="absolute top-0 left-0 p-2"
            onClick={handleDrawerToggle}
          >
            <CloseRoundedIcon />
          </button>
          <nav className="flex flex-col uppercase text-sm font-medium  normal-case ">
            {navLinks.map((link) => (
              <details key={link.name} className="group">
                <summary
                  className="flex items-center  justify-between group text-black group  hover:text-[#F7941D] group-open:text-[#F7941D] group-open:bg-[#F7941D]/[0.1]  block p-5  hover:bg-[#F7941D]/[0.1]"
                  onClick={() => {
                    if (!link.subnav) {
                      handleDrawerToggle();
                      navigate(link.path);
                    }
                  }}
                >
                  <p className="cursor-pointer">{t(link.name)}</p>
                  {link.subnav && (
                    <div className="group-open:rotate-180 transition-all cursor-pointer">
                      <ExpandMoreOutlinedIcon />
                    </div>
                  )}
                </summary>

                {link.subnav &&
                  link?.subnav.map((subnav) => (
                    <div className="flex flex-col p-5" key={subnav.name}>
                      {subnav.name && (
                        <h3 className="font-semibold text-sm uppercase text-[#151686] mb-[10px]">
                          {t(subnav.name)}
                        </h3>
                      )}
                      <ul className={`${width > 450 ? "w-[356px]" : null}`}>
                        {subnav.item.map((sublink, index) => (
                          <div
                            className="group/subnavlink"
                            key={index}
                            onClick={handleDrawerToggle}
                          >
                            {sublink.name && (
                              <h4 className="text-[12px] font-medium rounded group-hover/subnavlink:text-[#958FED] group-hover/subnavlink:bg-[#F2F5FE]">
                                {sublink.name}
                              </h4>
                            )}
                            {sublink.item &&
                              sublink.item.map((item) => (
                                <li key={t(item.name)} className="">
                                  <Link
                                    to={item.path}
                                    className="flex p-[10px] items-center justify-between text-wrap font-normal hover:bg-[#EEF3FA] hover:text-[#151686] hover:font-semibold rounded"
                                  >
                                    {t(item.name)}
                                  </Link>
                                </li>
                              ))}
                          </div>
                        ))}
                      </ul>
                    </div>
                  ))}
              </details>
            ))}
          </nav>
        </nav>
        {/* Mobile */}
        <div className="flex flex-col p-2 gap-3 mt-3 justify-center">
          <a
            href="https://facialsense.mobile-id.vn/portal/login"
            target="_blank"
            rel="noopener noreferrer"
          >
            <PoppyButton
              title={t("header.login")}
              style={{
                width:"100%",
              }}
            />
          </a>

          <a
            href="https://facialsense.mobile-id.vn/portal/sign-up"
            target="_blank"
            rel="noopener noreferrer"
          >
            <LeafButton
              title={t("header.signup")}
              style={{
               width:"100%"
              }}
            />
          </a>
        </div>
      </Drawer>
    </header>
  );
};
Header.propTypes = {
  logo: PropTypes.string,
};
